import { useOutletContext } from "react-router-dom";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import LeftNav from "../../bloks/navigationwidgets/leftNav";
import HelmetSEO from "../../components/helmetSeo/helmetSeo";

import { useCompressedImage } from "../../components/storyblokImageBasic/helpers";

import GetComponentsFromBloks from "../../helpers/bloksRenderer";

import styles from "./about.module.scss";
import PageContentWrapper from "../../components/PageContentWrapper";

function AboutLayout() {
  const { story } = useOutletContext();

  let bodyComponents = [];
  if (story && story.content && story.content.body) {
    bodyComponents = GetComponentsFromBloks(story.content.body, story);
  }

  let leftNavComponent = null;
  if (story && story.content && story.content.left_navigation) {
    const items = story.content.left_navigation;
    leftNavComponent = <LeftNav items={items} />;
  }

  let rightImage = null;
  if (story && story.content && story.content.right_image) {
    rightImage = story.content.right_image;
  }

  let bottomImage = null;
  if (story && story.content && story.content.bottom_image) {
    bottomImage = story.content.bottom_image;
  }

  const scrollPaddingForMobile =
    "@media screen and (max-width: 992px) { html { scroll-padding-top: 100px; } }";
  const scrollPaddingForExtraSmall =
    "@media screen and (max-width: 450px) { html { scroll-padding-top: 70px; } }";

  return (
    <>
      <HelmetSEO
        lang={story && story.lang ? story.lang : "en"}
        story_alternates={story ? story.alternates : []}
        seo_data={
          story && story.content && story.content.seo ? story.content.seo : {}
        }
        fallback_title={story && story.name ? story.name : ""}
        fallback_description={""}
        fallback_image_url={
          rightImage && rightImage.filename ? rightImage.filename : ""
        }
      />
      {/* Currently the only way we know how to override the scroll padding on a per page basis */}
      <style
        dangerouslySetInnerHTML={{
          __html: `${scrollPaddingForMobile} ${scrollPaddingForExtraSmall}`,
        }}
      ></style>
      <Navbar story_language={story ? story.lang : ""} />
      <PageContentWrapper>
        <div className={styles.root}>
          <div className={styles.navWrapper}>
            <div className={styles.nav}>{leftNavComponent}</div>
          </div>
          <div className={`page-content ${styles.middleColumn}`}>
            <img
              className={styles.topImage}
              src={rightImage ? useCompressedImage(rightImage.filename) : ""}
              alt={rightImage ? rightImage.alt : ""}
            />
            <div className={styles.bodyComponents}>{bodyComponents}</div>
            <img
              className={styles.bottomImage}
              src={bottomImage ? useCompressedImage(bottomImage.filename) : ""}
              alt={bottomImage ? bottomImage.alt : ""}
            />
          </div>
          <img
            className={styles.rightImage}
            src={rightImage ? useCompressedImage(rightImage.filename) : ""}
            alt={rightImage ? rightImage.alt : ""}
          />
        </div>
      </PageContentWrapper>
      <Footer />
    </>
  );
}

export default AboutLayout;
